export default __webpack_public_path__ + "static/media/tokenBadgeBronze108@2x.0b943a64.png";